/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2021, Bulb Inc.  For more information, please email contact@hellobulb.com.
 *
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
 *
 */

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { AeroModule } from '../../aero/aero.module';
import { BulbCommonModule } from '../../common/bulb-common.module';
import { CentToDollarConverterPipe } from './cent-to-dollar-converter.pipe';
import { PlanListComponent } from './plan-list.component';
import { PlanListService } from './plan-list.service';

/**
 * Module for displaying bulb plan features and prices.
 */
@NgModule({
  declarations: [CentToDollarConverterPipe, PlanListComponent],
  imports: [
    AeroModule,
    BulbCommonModule,
    CommonModule,
    TranslocoModule,
  ],
  exports: [
    CentToDollarConverterPipe,
    PlanListComponent,
  ],
  providers: [
    PlanListService,
  ],
})
export class PlanListModule { }
